const TAG_NAME = 'shopify-planner-helper';

if (!window.customElements.get(TAG_NAME)) {
    class ShopifyPlannerHelper extends HTMLElement {
        constructor() {
            super();

            this._setupListeners();
            this._init();
        }

        _init() {
            const frameUrl = new URL('https://borddesigner.designerzoo.dk/dk'); // TODO: Change URL
            const searchParams = new URL(window.location).searchParams;
            const config = searchParams.get('config');

            if (config) {
                frameUrl.searchParams.append('config', config);
            }

            const family = searchParams.get('family');

            if (family) {
                frameUrl.searchParams.append('family', family);
            }

            frameUrl.searchParams.append('iframe', '1');

            this._setFrameUrl(frameUrl.toString());
        }

        _setFrameUrl(url) {
            const frame = this.querySelector('iframe');

            if (!frame) {
                return;
            }

            frame.src = url;
        }

        _setupListeners() {
            window.addEventListener('message', this._onMessageEvent.bind(this));
        }

        _onMessageEvent(event) {
            if (!event.data?.type) {
                return;
            }

            switch (event.data.type) {
                case 'cart:submit':
                    return this._onCartSubmit(event);
            }
        }

    async _onCartSubmit(event) {
    const items = event.data.detail.items.map(item =>
        this._toIdQtySet(item, event.data.detail.configuration)
    );

    await this._addToCart(items);

    window.location.reload();

            // TODO: Update cart drawer with updated cart contents
            // TODO: Handle that cart drawer is opened
        }

        _getLocaleAwareUrlRoot(path = '') {
            return window?.Shopify?.routes?.root + path;
        }

        _addToCart(items) {
            return fetch(this._getLocaleAwareUrlRoot('cart/add.js'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ items })
            })
                .then(response => response.json())
        }

        _toIdQtySet(item, configuration) {
            if (!item.variant_id) {
                throw new Error('variant_id not found: Planner is most likely not using ShopifyCheckout or a product is missing a variant_id.');
            }

            return {
                id: item.variant_id,
                quantity: item.quantity,
                properties: {
                    _planner_code: configuration.code,
                    Bundle: 'Bønnebord',
            _bundle_id: configuration.code
                }
            };
        }
    }

    window.customElements.define(TAG_NAME, ShopifyPlannerHelper);
}